import React from "react";
import { Calendar, Clock, CaretLeft, PhoneCall } from "@phosphor-icons/react";

/** Step 2 of the consult flow, user details form, with a small summary chip
 * at the top that lets you jump back to the date/time step. */
export default function YourDetailsStep({ form, setForm, onBack, onSubmit, busy, lockIdentity = false }) {
  return (
    <form onSubmit={onSubmit} className="md-consult-step" data-testid="consult-step-you-body">
      <div className="consult-summary" data-testid="consult-summary">
        <Calendar size={14} weight="duotone" />
        <span>{form.date ? new Date(form.date).toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long" }) : ""}</span>
        <span aria-hidden>·</span>
        <Clock size={14} weight="duotone" />
        <span>{form.time_slot}</span>
        <button type="button" onClick={onBack} className="consult-summary-edit" data-testid="consult-summary-edit">Edit</button>
      </div>

      <div className="grid md:grid-cols-2 gap-3 mt-1">
        <div>
          <label className="md-label-eyebrow block mb-1.5">Name</label>
          <input required className="md-input" value={form.name} readOnly={lockIdentity} onChange={(e) => !lockIdentity && setForm({ ...form, name: e.target.value })} data-testid="consult-name" />
        </div>
        <div>
          <label className="md-label-eyebrow block mb-1.5">Email</label>
          <input required type="email" className="md-input" value={form.email} readOnly={lockIdentity} onChange={(e) => !lockIdentity && setForm({ ...form, email: e.target.value })} data-testid="consult-email" />
        </div>
        <div>
          <label className="md-label-eyebrow block mb-1.5">Phone *</label>
          <input required type="tel" className="md-input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="consult-phone" />
        </div>
        <div>
          <label className="md-label-eyebrow block mb-1.5">Division</label>
          <select className="md-input" value={form.division} onChange={(e) => setForm({ ...form, division: e.target.value })} data-testid="consult-division">
            <option value="couch">Couch, clinical/therapy</option>
            <option value="forward">Forward, mentorship</option>
          </select>
        </div>
      </div>

      <div>
        <label className="md-label-eyebrow block mb-1.5">What&apos;s on your mind (optional)</label>
        <textarea className="md-input" rows={3} value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} data-testid="consult-reason" />
      </div>

      <div className="consult-step-nav mt-3">
        <button type="button" onClick={onBack} className="btn-outline text-sm" data-testid="consult-back">
          <CaretLeft size={14} weight="bold" /> Back
        </button>
        <button type="submit" disabled={busy} className="btn-primary text-sm" data-testid="consult-submit">
          <PhoneCall size={14} weight="bold" /> {busy ? "Booking…" : "Book a Free Consultation"}
        </button>
      </div>
    </form>
  );
}
